document.addEventListener('DOMContentLoaded', () => {
    new Swiper(".swiper-conf", {
        spaceBetween: 20,
        centeredSlides: false,
        slidesPerView: 1.5,
        loop: false,
        slideToClickedSlide: true,

        // enable accessibility
        a11y: true,
        keyboard: {
            enabled: true,
            onlyInViewport: false
        },
        freeMode: false
    });
});

const carouselButtons = document.querySelectorAll(".js-carousel-link");
carouselButtons.forEach((button) => {
    const tag = JSON.parse(button.dataset.tag)
    button.addEventListener("click", () => Tms.link(tag))
});


